import React from 'react';
import {Button, Input, Popover} from "antd";
import * as PropTypes from "prop-types";

const { Search } = Input;

// RFC1035-compliant domain name check
const validateEmail = (email) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]([-a-zA-Z0-9]*[a-zA-Z0-9])?)$/.test(email);

export class QuickInviteButton extends React.Component {
  state = {
    visible: false,
    empty: false,
    invalid: false,
  };

  handleSearch = (email) => {
    const { onInvite } = this.props;
    if (!onInvite) return;
    if (!email.trim()) {
      this.setState({ empty: true, invalid: false, email });
      return;
    }
    if (!validateEmail(email)) {
      this.setState({ empty: false, invalid: true, email });
      return;
    }
    this.setState({ visible: false, empty: false, invalid: false, email });
    onInvite(email) && this.setState({ visible: false, empty: false, invalid: false, email: '' });
  };

  render() {
    const { style, disabled, onInvite, ...rest } = this.props;
    const { email } = this.state;
    const title = this.props.title || 'Quick Invite';
    return <Popover
      overlayClassName='quick-invite-popover'
      openClassName='quick-invite-popover'
      className='quick-invite-popover'
      placement='bottom'
      trigger='click'
      visible={this.state.visible}
      onVisibleChange={visible => disabled || this.setState({ visible })}
      content={<div>
        <Search placeholder='Enter an email...' enterButton='Invite' value={email}
                onChange={e => this.setState({email: e.target.value})}
                onSearch={this.handleSearch} />
        <div className='color-secondary-1-0' style={{display: !this.state.empty && 'none'}}>Email address can not be blank.</div>
        <div className='color-secondary-1-0' style={{display: !this.state.invalid && 'none'}}>Must be a valid email address.</div>
        <div className='color-grayscale-3'>Enter the email address of the person you wish to invite.</div>
      </div>}
    >
      <Button {...rest} disabled={disabled} icon='user-add'><span
        className='hidden inline visible-xl'>{title}</span></Button>
    </Popover>;
  }
}

QuickInviteButton.propTypes = {
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Boilerplate/QuickInviteButton.js